import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './Payment.css';
import { useHistory, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function PaymentFailed() {
    const history = useHistory();
    const dispatch = useDispatch();
    const { orderId } = useParams();
    

    return (
        <>
            <div className="container-fluid event-grid">
                <Helmet>
                    <meta name="description" content="Please contact us using this form if you face any problem. Our team will help you in any case..." />
                    <title>Payment Success | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="col-md-10 mx-auto about__us text-left">
                    <div className="failed_container">
                        <div className="printer-top"></div>
                            
                        <div className="paper-container">
                            <div className="printer-bottom"></div>
                            <div className="paper_failed">
                                <div className="main-contents">
                                    <div className="success-icon">&#10004;</div>
                                    <div className="success-title">
                                        Payment Failed
                                    </div>
                                    <div className="success-description">
                                        Payment Verification Failed, Please Try Again later!!
                                    </div>
                                    <div className="order-footer">Thank you!</div>
                                </div>
                                <div className="jagged-edge"></div>
                            </div>
                        </div>
                        </div>
                </div>
            </div>
        </>
    )
}

export default PaymentFailed
